import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAsyncEffect } from "@ispb/react-hooks";
import { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { When } from "react-if";
import { useZxing } from "react-zxing";
import { cameraErrorToString } from "../camera/index.js";
import Spacer from "../components/Spacer.js";
import { DebugContext } from "../components/WithDebug.js";
import { MAX_CAMERA_WIDTH } from "../config.js";
import { CAMERA_ICON } from "../icons.js";
import ThumbnailBox from "../thumbnail/box/ThumbnailBox.js";
import ThumbnailIcon from "../thumbnail/box/ThumbnailIcon.js";
const QR_DELAY = 500;
const QR_ASPECT_RATIO = 1;
const QR_CONSTRAINTS = {
    facingMode: {
        exact: "environment",
    },
};
export default function QRReader(props) {
    //const ref = useRef<Webcam>(null)
    const debug = useContext(DebugContext);
    const [qrCode, setQrCode] = useState();
    const [cameraError, setCameraError] = useState();
    const zxing = useZxing({
        onDecodeResult: result => setQrCode(result.rawValue),
        onError: setCameraError,
        constraints: {
            video: QR_CONSTRAINTS,
        },
        timeBetweenDecodingAttempts: QR_DELAY,
    });
    /*
    useAsyncEffect(async () => {
        try {
            const reader = new BrowserQRCodeReader(undefined, { delayBetweenScanAttempts: QR_DELAY })
            const result = await reader.decodeFromConstraints({ audio: false, video: QR_CONSTRAINTS })
            setQrCode(result.getText())
            reader.reset()
        }
        catch (e) {
            setCameraError(e)
        }
    }, [
        ref,
    ])*/
    useAsyncEffect(async () => {
        if (qrCode === undefined) {
            return;
        }
        await props.setValue(qrCode);
    }, [
        qrCode
    ]);
    useEffect(() => {
        const ref = zxing.ref.current;
        if (ref === null) {
            return;
        }
        if (props.busy) {
            ref.pause();
        }
        else {
            ref.play();
        }
    }, [
        props.busy
    ]);
    const maxWidth = props.fullSize ? undefined : MAX_CAMERA_WIDTH;
    if (cameraError !== undefined) {
        const errorString = cameraErrorToString(cameraError);
        return (_jsxs("div", { style: { maxWidth }, children: [_jsx(ThumbnailBox, { variant: "danger", aspectRatio: QR_ASPECT_RATIO, children: _jsx(ThumbnailIcon, { icon: CAMERA_ICON, children: _jsx("small", { children: errorString }) }) }), _jsx(Spacer, {}), _jsxs(When, { condition: debug, children: [_jsx(Button, { onClick: () => setQrCode("1"), children: "Inject \"1\"" }), _jsx(Spacer, {})] })] }));
    }
    else if (props.disabled) {
        return (_jsxs("div", { style: { maxWidth }, children: [_jsx(ThumbnailBox, { aspectRatio: QR_ASPECT_RATIO, children: _jsx(ThumbnailIcon, { icon: CAMERA_ICON }) }), _jsx(Spacer, {})] }));
    }
    else {
        return (_jsxs("div", { style: { maxWidth }, children: [_jsx("video", { ref: zxing.ref, className: "d-block w-100 bg-black", style: { aspectRatio: QR_ASPECT_RATIO } }), _jsx(Spacer, {})] }));
    }
}
